import { render, staticRenderFns } from "./base-crud-buttons.vue?vue&type=template&id=6a480494&scoped=true&"
import script from "./base-crud-buttons.vue?vue&type=script&lang=js&"
export * from "./base-crud-buttons.vue?vue&type=script&lang=js&"
import style0 from "./base-crud-buttons.vue?vue&type=style&index=0&id=6a480494&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a480494",
  null
  
)

export default component.exports